import { request } from 'utils/ajax';
import { PaginatedSearchRequest, PaginationResult } from 'types';
import { FeatureDefinitionDTO } from './featureDefinition';

export function getProfileFeatures(
    req: FeatureToggleSearchRequest
): Promise<PaginationResult<FeatureToggleWithDefinitionDTO>> {
    return request(`api/FeatureToggle/profile`, {
        query: req,
    }).then((x) => x.json());
}

export function getProjectFeatures(
    req: FeatureToggleSearchRequest
): Promise<PaginationResult<FeatureToggleWithDefinitionDTO>> {
    return request(`api/FeatureToggle/project`, {
        query: req,
    }).then((x) => x.json());
}

export function postFeature(featureToggle: FeatureToggleDTO) {
    return request(`api/FeatureToggle`, {
        body: featureToggle,
        method: 'POST',
        json: true,
    });
}

export function searchProfileFeatures(req: FeatureToggleSearchRequest): Promise<PaginationResult<FeatureToggleProfileDTO>> {
    return request(`api/FeatureToggle/search-profiles`, {
        query: {...req, },
    }).then((x) => x.json());
}
export function searchProjectFeatures(req: FeatureToggleSearchRequest): Promise<PaginationResult<FeatureToggleProjectDTO>> {
    return request(`api/FeatureToggle/search-projects`, {
        query: req,
    }).then((x) => x.json());
}
export interface FeatureToggleWithDefinitionDTO extends FeatureDefinitionDTO {
    projectToggled: boolean;
    profileToggled: boolean;
    toggled: boolean;
}

export interface FeatureToggleSearchRequest extends PaginatedSearchRequest {
    profileId?: number;
    projectId?: number;
    feature?: string;
}

export interface FeatureToggleDTO {
    profileId?: number;
    projectId?: number;
    toggled: boolean;
    featureName: string;
    createdByEmail?: string;
    updatedByEmail?: string;
    createDate?: Date;
    updateDate?: Date;
}

export interface FeatureToggleProfileDTO extends FeatureToggleDTO {
    profileName: string;
}
export interface FeatureToggleProjectDTO extends FeatureToggleDTO {
    projectName: string;
    profileToggled: boolean;
}
